// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__28y43","header":"ReportDetails_header__19Hxr","title":"ReportDetails_title__2hgJo","left":"ReportDetails_left__3uD0Z"};